import { PropsWithChildren } from 'react';
import { useAppContext } from '@features/contexts/AppProvider';
import { LogTypeKeys } from '@features/components/ClinicalData/components/ClinicalLog/types';
import cn from 'classnames';
import { LogItemStyleKey } from './constants';

type LogItemLayoutProps = {
  className?: string;
} & PropsWithChildren;

const cssStyles: Record<LogItemStyleKey, string> = {
  [LogItemStyleKey.base]: '',
  [LogItemStyleKey.minor]: 'w-[263px]',
};

export const LogItemLayout = ({ children, className = 'bg-base-70' }: LogItemLayoutProps) => {
  const {
    clinicalLog: { styles },
  } = useAppContext();

  return (
    <div
      className={cn(
        'relative flex h-fit flex-col py-2 px-3 rounded-lg',
        cssStyles[styles[LogTypeKeys.LogItemLayout] as LogItemStyleKey],
        className,
      )}
    >
      {children}
    </div>
  );
};
